import React from 'react';


export default function InlineLoading() {
    return <><div class="text-center"><div class="spinner-border spinner-border-sm" role="status">
    <span class="visually-hidden">Loading...</span>
  </div></div></>;
}
